module.exports = __webpack_public_path__ + "img/fish_goldfish.051e4465.png";